import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_Profile = _resolveComponent("Profile")!
  const _component_LanguageSettings = _resolveComponent("LanguageSettings")!
  const _component_ServerInfo = _resolveComponent("ServerInfo")!
  const _component_Activate = _resolveComponent("Activate")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_splitter, {
      modelValue: _ctx.splitterModel,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.splitterModel) = $event))
    }, {
      before: _withCtx(() => [
        _createVNode(_component_q_tabs, {
          modelValue: _ctx.tab,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
            _ctx.onTabChange
          ],
          vertical: "",
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createBlock(_component_q_tab, {
                key: option.name,
                name: option.name,
                icon: option.icon,
                label: _ctx.t(option.title)
              }, null, 8, ["name", "icon", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      after: _withCtx(() => [
        _createVNode(_component_q_tab_panels, {
          modelValue: _ctx.tab,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
          animated: "",
          swipeable: "",
          vertical: "",
          "transition-prev": "jump-up",
          "transition-next": "jump-up"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createBlock(_component_q_tab_panel, {
                key: option.name,
                name: option.name
              }, {
                default: _withCtx(() => [
                  (_ctx.tab == 'profile')
                    ? (_openBlock(), _createBlock(_component_Profile, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_ctx.tab == 'language')
                    ? (_openBlock(), _createBlock(_component_LanguageSettings, { key: 1 }))
                    : _createCommentVNode("", true),
                  (_ctx.tab=='serverinfo')
                    ? (_openBlock(), _createBlock(_component_ServerInfo, { key: 2 }))
                    : _createCommentVNode("", true),
                  (_ctx.tab=='activate')
                    ? (_openBlock(), _createBlock(_component_Activate, { key: 3 }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}